export const ImagotipoDynamicDashboard = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.9448 12.6165V13.6165H10.9448H20.2805C19.779 18.3685 15.7495 22.1127 10.9448 22.1127C5.80769 22.1127 1.55664 17.8324 1.55664 12.6165C1.55664 7.40034 5.80806 3.11743 10.9448 3.11743C11.5804 3.11743 12.2135 3.18265 12.8336 3.31148L9.99122 12.3124L9.9448 12.4594V12.6136V12.6165Z" stroke="#003366" strokeWidth="2" />
            <path d="M20.9514 5.26677L20.9519 5.26742C21.9171 6.60525 22.5156 8.17261 22.6941 9.8086L14.742 9.85213L17.2312 2.20583C18.7057 2.88076 19.9901 3.93208 20.9514 5.26677Z" stroke="#003366" strokeWidth="2" />
        </svg>
    )
}
